import profileCommon from './Common';
import profileInformations from './Informations';
import profileBilling from './Billing';
import profilePassword from './Password';

export default {
    profileCommon,
    profileInformations,
    profileBilling,
    profilePassword,
};
